/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import CartTitle from "../CartTitle";
import moment from "moment";
import { Row, Col, Card, CardBody, Label, FormGroup, Button } from "reactstrap";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import Loader from "../Loader";
import { fetchQueryParams } from "../../utils/comman";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import get from "lodash/get";

const _ = { get };

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  callingCode: "",
  motorcycleCode: "",
  motorcycleName: "",
  motorcycleColor: "",
  vin: "",
  branch: "",
  userID: "",
  userGUID: "",
  locality: "",
  cluster: "",
  welcomeGiftReceived: false,
};

function Informatin(props) {
  let { elements } = props;
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    const params = fetchQueryParams(props.query);

    if (props.vechicleDetail !== null) {
      state.firstName = props.vechicleDetail.userID.fName;
      state.lastName = props.vechicleDetail.userID.lName;
      state.email = props.vechicleDetail.userID.contactDetails.email;
      state.mobile =
        props.vechicleDetail.userID.contactDetails.mobile.primary.number;
      state.callingCode =
        props.vechicleDetail.userID.contactDetails.mobile.primary.callingCode;
      state.motorcycleCode = "";
      state.motorcycleName = props.vechicleDetail.vehicleModelName;
      state.motorcycleColor = props.vechicleDetail.vehicleModelColor;
      state.vin = props.vechicleDetail.vin;
      state.branch = props.vechicleDetail.branch;
      state.userID = props.vechicleDetail.userID._id;
      state.userGUID = props.vechicleDetail.userGUID;
      state.cluster =
        props.vechicleDetail.userID !== null
          ? props.vechicleDetail.userID.cluster
          : "";
      setstate({ ...state });
    } else {
      props.handleFetchVechileData(params.vehicleId);
    }
  }, [props.vechicleDetail]);

  const handleWelcomeGift = (e, id) => {
    if (id === "Yes") {
      state.welcomeGiftReceived = true;
    } else {
      state.welcomeGiftReceived = false;
    }
    setstate({ ...state });
  };

  const handleSumbit = () => {
    if (state.cluster !== "") {
      let data = {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        mobile: state.mobile,
        callingCode: state.callingCode,
        motorcycleCode: state.motorcycleCode,
        motorcycleName: state.motorcycleName,
        motorcycleColor: state.motorcycleColor,
        vin: state.vin,
        branchId:
          props.userProfile.additionalInfo !== null
            ? props.userProfile.additionalInfo.branchId
            : "",
        userID: state.userID,
        userGUID: state.userGUID,
        userCluster: state.cluster,
        welcomeGiftReceived: state.welcomeGiftReceived,
      };
      props.handleRidersRegister(data);
      // console.log({data})
    } else {
      toast.error(
        _.get(
          elements,
          "riderRegistrationElements.clusterValidationElement",
          "Cluster not found"
        )
      );
    }
  };

  return (
    <React.Fragment>
      {props.vechicleDetailStatus !== false ? <Loader /> : null}
      {props.ridersRegisterStatus !== false ? <Loader /> : null}
      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "riderRegistrationElements.headingElement",
                "User Registration"
              )}
              iconClass={"hideexcel"}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
            />
          </Col>
        </Row>
        <Card className="mb-3">
          <CardBody>
            {props.vechicleDetail !== null ? (
              <Row>
                <Col md="12">
                  <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "riderRegistrationElements.subHeadingRiderElement",
                        "Rider Details"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.fNameLabel",
                      "First Name"
                    )}
                    titleName={props.vechicleDetail.userID.fName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.lNameLabel",
                      "Last Name"
                    )}
                    titleName={props.vechicleDetail.userID.lName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.genderLabel",
                      "Gender"
                    )}
                    titleName={props.vechicleDetail.userID.gender}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.dobLabel",
                      "Date of Birth"
                    )}
                    titleName={moment(props.vechicleDetail.userID.dob).format(
                      "DD-MM-YYYY"
                    )}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.emailLabel",
                      "Email Id"
                    )}
                    titleName={props.vechicleDetail.userID.contactDetails.email}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.countryCodeLabel",
                      "Calling Code"
                    )}
                    titleName={
                      props.vechicleDetail.userID.contactDetails.mobile.primary
                        .callingCode
                    }
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.mobileLabel",
                      "Mobile Number"
                    )}
                    titleName={
                      props.vechicleDetail.userID.contactDetails.mobile.primary
                        .number
                    }
                  />
                </Col>
                <Col md="12">
                  <h2 className="title-bar secondary-title f-weight-bold my-3 pb-2 themeColor">
                    <span>
                      {_.get(
                        elements,
                        "riderRegistrationElements.subHeadingVehicleElement",
                        "Vehicle Details"
                      )}
                    </span>
                  </h2>
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.motorCycleLabel",
                      "Motorcycle"
                    )}
                    titleName={props.vechicleDetail.vehicleModelName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.variantLabel",
                      "Variant"
                    )}
                    titleName={props.vechicleDetail.vehicleModelColor}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.registrationNumberLabel",
                      "Registration Number"
                    )}
                    titleName={props.vechicleDetail.registrationNo}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.vinLabel",
                      "VIN"
                    )}
                    titleName={props.vechicleDetail.vin}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "riderRegistrationElements.dateOfPurchaseLabel",
                      "Date Of Purchase"
                    )}
                    titleName={moment(props.vechicleDetail.dateOfMfg).format(
                      "DD-MM-YYYY"
                    )}
                  />
                </Col>
                <Col xl={4} lg={4} md={6} sm={6} className="mb-2">
                  <Label className="inputLabel">
                    {_.get(
                      elements,
                      "userCreationElements.welcomeGiftReceivedLabel",
                      "Welcome Gift Received?*"
                    )}
                  </Label>
                  <Row>
                    <Col>
                      <FormGroup className="d-flex align-items-center">
                        <div className="defaultbtn customCheck   checkbtn">
                          <Button
                            type="button"
                            className={`btn-outline-dark bg-none  mr-2 ${
                              state.welcomeGiftReceived === true
                                ? "btnthemeColor"
                                : ""
                            }`}
                            onClick={(e) => handleWelcomeGift(e, "Yes")}
                          ></Button>
                        </div>
                        <div className="">
                          <span>
                            {_.get(
                              elements,
                              "userCreationElements.yesForWelcomeGiftElement",
                              "Yes"
                            )}
                          </span>
                        </div>
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup className="d-flex align-items-center">
                        <div className="defaultbtn customCheck   checkbtn">
                          <Button
                            type="button"
                            className={`btn-outline-dark bg-none  mr-2 ${
                              state.welcomeGiftReceived === false
                                ? "btnthemeColor"
                                : ""
                            }`}
                            onClick={(e) => handleWelcomeGift(e, "No")}
                          ></Button>
                        </div>
                        <div className="">
                          <span>
                            {_.get(
                              elements,
                              "userCreationElements.noForWelcomeGiftElement",
                              "No"
                            )}
                          </span>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col md="12">
                  <div className="d-flex justify-content-center justify-content-lg-end position-relative my-3 ">
                    <CustomButton
                      customType={"button"}
                      name={_.get(
                        elements,
                        "riderRegistrationElements.submitButtonElement",
                        "Register"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={(e) => handleSumbit(e)}
                    />
                  </div>
                </Col>
              </Row>
            ) : null}
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
}

export default Informatin;
